<script lang="ts" setup>
	defineProps<{ title?: string }>()
	const cls = String(useAttrs()?.class ?? '')
</script>
<template>
	<h1
		:class="
			cn(
				'maitree-bold text-[2em] xs:text-[2.6em] text-[inherit] lg:text-[4.25em] lg:leading-[80px] xs:leading-[50px] leading-[40px] text-balance ',
				cls
			)
		"
	>
		<slot>
			<span v-html="title"></span>
		</slot>
	</h1>
</template>

<style></style>
